import { combine, createEffect, guard } from "effector";
import { $audioCurrentTime } from "frontend/src/domain/audio";
import { $playerCurrentTrack, $playerNextTrack, } from "frontend/src/domain/player-track-queue";
var audio = new Audio();
var preloadNextAudioFx = createEffect(function (track) {
    if (track && audio.src !== track.url) {
        audio.src = track.url;
        if (audio.readyState < 2) {
            audio.load();
        }
    }
});
guard({
    clock: $audioCurrentTime,
    source: combine({
        duration: $playerCurrentTrack.map(function (track) { var _a; return (_a = track === null || track === void 0 ? void 0 : track.duration.seconds) !== null && _a !== void 0 ? _a : 0; }),
        nextTrack: $playerNextTrack,
    }),
    filter: function (_a, currentTime) {
        var duration = _a.duration, nextTrack = _a.nextTrack;
        return nextTrack !== null && duration - currentTime < 20;
    },
    target: preloadNextAudioFx.prepend(function (_a) {
        var nextTrack = _a.nextTrack;
        return nextTrack;
    }),
});
